var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { baseCommon, configCommon, merchantCommon, } from '@repo/api/endpoints/merchant/msw/mocks/common';
export var LOAN_APPLICATION_POSSIBLE_WITH_SELECTED_MARKETING_DATA = __assign(__assign({}, baseCommon), { type: 'IFRAME_MERCHANT_SUMMARY', currentProvider: ['test-provider'], data: {
        merchantData: __assign(__assign({}, merchantCommon), { user: {
                type: 'user',
                userId: 12345,
                permission: {
                    widget: true,
                    newLoan: true,
                    cancelLoan: true,
                    continueLoan: true,
                },
                accessFor: ['193421', '1234', '4321'],
            } }),
        preLimits: [
            {
                id: 12345,
                min: 10000,
                max: 5000,
                currency: 'PLN',
                provider: 'test-provider',
                availableLimitRevenueRate: [
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 6,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
            },
        ],
        limits: [
            {
                id: 1732011441,
                preLimitId: 1732011441,
                min: 3000,
                max: 50000,
                used: 48000,
                currency: 'PLN',
                provider: 'test-provider',
                availableLimitRevenueRate: [
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 6,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
                minMaxDifference: false,
                available: 2000,
            },
        ],
        loans: [],
        agreements: {
            marketing: [
                {
                    provider: 'przelewy24',
                    accepted: true,
                    timestamp: '2024-05-16T07:38:18.593Z',
                },
            ],
        },
        transfers: [
            {
                provider: 'test-provider',
                taxId: '1111111111',
                pos: '789',
                batchId: 0,
                details: {
                    amount: 100,
                    currency: 'PLN',
                    iban: '990',
                    title: 'test',
                    id: '1',
                    createdAt: '2025.02.25',
                },
            },
            {
                provider: 'test-provider',
                taxId: '1111111111',
                pos: '789',
                batchId: 0,
                details: {
                    amount: 100,
                    currency: 'PLN',
                    iban: '990',
                    title: 'test',
                    id: '2',
                    createdAt: '2025.02.25',
                },
            },
            {
                provider: 'test-provider',
                taxId: '1111111111',
                pos: '789',
                batchId: 0,
                details: {
                    amount: 100,
                    currency: 'PLN',
                    iban: '990',
                    title: 'test',
                    id: '3',
                    createdAt: '2025.02.24',
                },
            },
            {
                provider: 'test-provider',
                taxId: '1111111111',
                pos: '789',
                batchId: 0,
                details: {
                    amount: 100,
                    currency: 'PLN',
                    iban: '990',
                    title: 'test',
                    id: '4',
                    createdAt: '2025.02.24',
                },
            },
        ],
        offers: [],
    }, config: configCommon });
